export const BUSINESS = 'business';
export const DEFAULT = 'default';
